import React, { useMemo } from 'react'
import type { InputProps as CurrencyInputProps } from 'react-currency-input-field'
import CurrencyInputBase from 'react-currency-input-field'
import { getCurrencyInfo } from '@helpers/utils'

export type InputProps = CurrencyInputProps & {
  currency?: string
  isCurrency?: boolean
}

const DEFAULT_SCALE = 2
const DEFAULT_LIMIT = 2

export const CurrencyInput: React.FC<InputProps> = (props) => {
  const { currency, isCurrency, decimalScale: decimalScaleProp, decimalsLimit: decimalsLimitProp, ...rest } = props

  const info = useMemo(() => {
    const handleAsCurrency = isCurrency ?? true
    let decimalScale = decimalScaleProp ?? (handleAsCurrency ? DEFAULT_SCALE : undefined)
    let decimalsLimit = decimalsLimitProp ?? (handleAsCurrency ? DEFAULT_LIMIT : undefined)

    if (!currency) return { decimalScale, decimalsLimit }

    const { hasDecimal } = getCurrencyInfo(currency)

    if (!hasDecimal) {
      decimalScale = 0
      decimalsLimit = 0
    }

    return { decimalScale, decimalsLimit }
  }, [currency, isCurrency, decimalScaleProp, decimalsLimitProp])

  return (
    <CurrencyInputBase
      decimalSeparator="."
      groupSeparator=","
      intlConfig={{
        locale: 'en-US',
        currency: isCurrency ? currency : undefined,
      }}
      decimalScale={info.decimalScale}
      decimalsLimit={info.decimalsLimit}
      {...rest}
    />
  )
}

export default React.memo(CurrencyInput)
